import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import api, { mediaUrl } from "@/lib/api";
import { useSEO } from "@/lib/seo";

const LookbookPage = () => {
  const [items, setItems] = useState(null);
  useSEO({ title: "The Lookbook | NoirbyAmara", description: "Shoppable editorial stories — see the pieces styled and worn." });
  useEffect(() => { window.scrollTo(0, 0); api.get("/lookbooks").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <div data-testid="lookbook-index" className="max-w-[1600px] mx-auto px-6 md:px-10 pt-16 md:pt-24 min-h-[60vh]">
      <p className="overline text-gold mb-4">The Lookbook</p>
      <h1 className="font-serif text-5xl md:text-8xl leading-none mb-14">Worn, and lived in.</h1>

      {items === null ? (
        <div className="grid md:grid-cols-2 gap-8">
          {[0, 1].map((i) => <div key={i} className="aspect-[4/5] bg-sand/50 animate-pulse" />)}
        </div>
      ) : items.length === 0 ? (
        <div className="text-center py-24">
          <p className="font-serif text-4xl mb-4">Stories coming soon.</p>
          <p className="text-espresso/60 max-w-md mx-auto">Our first shoppable editions are being styled. Return shortly to shop the looks.</p>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 gap-8 md:gap-12">
          {items.map((lb, i) => (
            <motion.div key={lb.id} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7, delay: i * 0.05 }}>
              <Link to={`/lookbook/${lb.slug}`} data-testid={`lookbook-card-${lb.slug}`} className="group block">
                <div className="img-zoom aspect-[4/5] overflow-hidden mb-5 bg-sand flex items-center justify-center">
                  {lb.hero_image
                    ? <img src={mediaUrl(lb.hero_image)} alt={lb.title} loading="lazy" className="w-full h-full object-cover" />
                    : <span className="font-serif text-espresso/50 text-sm tracking-[0.2em] uppercase">Imagery coming soon</span>}
                </div>
                <h2 className="font-serif text-3xl md:text-4xl leading-tight group-hover:text-gold transition-colors">{lb.title}</h2>
                {lb.intro && <p className="text-sm text-espresso/60 mt-2 leading-relaxed max-w-md">{lb.intro}</p>}
                <span className="inline-block mt-3 text-[0.68rem] tracking-[0.2em] uppercase text-espresso hover-underline">Shop the story</span>
              </Link>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LookbookPage;
